import { ConnectorTypes } from '@bciti/types';

export interface AllConnectorsResponse {
    connectors: Connector[];
}

export interface Connector {
    name: string;
    bciti_certified: boolean;
    description: string;
    endpoints: ConnectorEndpoint[];
    type: ConnectorTypes;
    version: string;
    configurations: ConnectorConfigurationElement[];
    technical_contact: string;
    tag: string;
    lookup: boolean;
}

/**
 * Connectors whose single catalogue entry serves several types.
 *
 * A catalogue entry carries one `type`, but PSD Citywide is typed 'Requests'
 * there while also exposing the three permit actions, so it has to be offered
 * under both tabs (BD-11295). Listing it here rather than in the catalogue
 * document keeps the declaration in Git and avoids writing to every
 * environment's database.
 *
 * Any tag absent from this map falls back to its catalogue `type`.
 */
export const CONNECTOR_TYPES_BY_TAG: Record<string, ConnectorTypes[]> = {
    PSDCITYWIDE: [ConnectorTypes.REQUESTS, ConnectorTypes.PERMITS],
};

export interface ConnectorEndpoint {
    url: string;
    action: string;
}

export interface ConnectorConfigurationElement {
    label: string;
    description: string;
    required: boolean;
    key: string;
    inputType: string;
}

export interface ConfiguredConnector {
    tag: string;
    type: ConnectorTypes;
    configurations: CCConfig;
}

export interface CCConfig {
    [key: string]: string;
}
